import HolidaysTableList from "../../../../component/holidays/holiday-list/HolidaysTableList";

export default function HolidaysTable() {
  return (
    <div className="page-body">
      <HolidaysTableList />
    </div>
  );
}
